export const CLASS_GANTT_CONTEXT_HINT = 'gantt-context-hint';
export const CLASS_HINT_HIDE_ON_CLICK = 'hint-hide-on-click';
export const GANTT_CONTEXT_TIMEOUT = 1000;
export const GANTT_CONTEXT_VIEW_ON_GANTT_TIMEOUT = 4000;
